module.exports = __webpack_public_path__ + "static/media/MY_Payslip_1.b020ae0e.png";